// extracted by mini-css-extract-plugin
export default {"col":"styles_col__79hRD","formContainer":"styles_formContainer__qF8sM","form":"styles_form__LcTPz"};